import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class UlazSirovinaService {
  constructor(private _http: HttpClient) {}

  dohvatiSkladistaSirovina(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'poslovnicaPopis', a)
      .pipe(map((res: any) => res));
  }

  dohvatiStavkeUlazaSirovina(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'rekapitulacijaFilter', a)
      .pipe(map((res: any) => res));
  }
}
